function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "share",
  transform: "translate(0.05 0.064)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M1.047,16.4A1.006,1.006,0,0,1,.23,15.6L.1,14.837c0-.014,0-.027-.007-.04A9.82,9.82,0,0,1,3.683,5.809,8.889,8.889,0,0,1,9,3.969V.994A.993.993,0,0,1,9.63.076,1.035,1.035,0,0,1,10.739.29L17.49,6.845a.978.978,0,0,1,0,1.4l-6.751,6.621a1.036,1.036,0,0,1-1.11.217A.992.992,0,0,1,9,14.17V11.083c-1.518.005-4.266.586-6.49,4.195l-.407.661a1.023,1.023,0,0,1-.872.482A1.106,1.106,0,0,1,1.047,16.4Z",
  transform: "translate(8.211)",
  fill: "#ff4f5a",
  stroke: "#ff4f5a",
  strokeMiterlimit: 10,
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M22.266,13.171a1.012,1.012,0,0,0-1,1.026v2.908H1.994V2.053H7.976a1.012,1.012,0,0,0,1-1.026A1.012,1.012,0,0,0,7.976,0H1A1.012,1.012,0,0,0,0,1.026V18.132a1.012,1.012,0,0,0,1,1.026H22.266a1.012,1.012,0,0,0,1-1.026V14.2A1.012,1.012,0,0,0,22.266,13.171Z",
  transform: "translate(0 4.105)",
  fill: "#ff4f5a",
  stroke: "#ff4f5a",
  strokeMiterlimit: 10,
  strokeWidth: 0.1
}));

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.1,
    height: 23.378,
    viewBox: "0 0 26.1 23.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.6e9d7e1f.svg";
export { ForwardRef as ReactComponent };